import React from "react";
import {connect} from 'react-redux';
import createReactClass from 'create-react-class';
import {AccountModes, URLs, FetchingTypes, PickupSiteTypes, INVALID_ADDRESS_HOME_DELIVERY} from "../../common/constants";
import {setAccountMode, getPickupSiteAvailableForChange, updatePickupSite, setShowAddressValidationMessage} from "../../actions/account/accountActions";
import {setPickupSitesAndDeliveryDate} from "../../actions/common/subscriptionSummaryActions";
import {checkIsDirty, setDirty} from '../../actions/common/commonActions';
import AccountNavigationHeader from "../../components/account/AccountNavigationHeader";
import PickupSiteSelection from "../common/PickupSiteSelection";
import {isFetching} from "../../actions/common/fetchingActions";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {isEmptyString, geocodeAddress, isEmptyObj} from "../../common/utils";
import ModalPopup from"../../components/common/ModalPopup";
import {updateMemberLatLng, setLatLng} from "../../actions/login/memberDetailsActions";
import {translate} from '../../i18n/translate.js';

const AccountChangePickupSite = createReactClass( {
    getInitialState() {
        return {
            buttons: {
                left: {
                    label: translate("CANCEL"),
                    onClick: this.onCancel
                },
                right: {
                    label: translate("SAVE"),
                    onClick: this.onSave,
                    disabled: true
                },
            },
            oldPickupSite: this.props.pickupSite,
            oldWaitListSite: this.props.waitListSite,
            oldNextDeliveryDateActual: this.props.nextDeliveryDateActual,
        }
    },
    getDefaultProps() {
        return {
            showAddressValidationMessage: false
        }
    },

    componentWillMount() {
        this.props.getPickupSiteAvailableForChange();
    },
    onCancel() {
        this.props.checkIsDirty(!this.props.isPreview, function() {
            this.props.cancel(this.state.oldPickupSite, this.state.oldWaitListSite, this.state.oldNextDeliveryDateActual);
        }.bind(this));
    },

    onSave() {
        if(this.props.pickupSite.type === PickupSiteTypes.ZONE || this.props.pickupSite === PickupSiteTypes.HOME) {
            const member = this.props.memberDetails;
            const address = member.addressLine1 + " " + member.city + " " + member.state + " " + member.zipCode;
            geocodeAddress(address).then(geoCode => {
                if (geoCode.lat) {
                    if(!this.props.memberDetails.lat || !this.props.memberDetails.lng) {
                        this.props.updateMemberLatLng(geoCode.lat, geoCode.lng);
                    }
                    this.props.save(this.props.pickupSite, this.props.waitListSite);
                } else {
                    this.props.setShowAddressValidationMessage(INVALID_ADDRESS_HOME_DELIVERY);
                }
            });
        } else {
            this.props.save(this.props.pickupSite, this.props.waitListSite);
        }
    },
    closeModal() {
        this.props.setShowAddressValidationMessage(undefined);
    },
    getValidateAddressModal() {
        if(this.props.showAddressValidationMessage) {
            return (<ModalPopup
                onClose={this.closeModal}
                message={this.props.showAddressValidationMessage}
                middle={{text: 'Close', callback: this.closeModal}}/>);
        }
    },
    componentWillReceiveProps(nextProps) {
        if((nextProps.pickupSite.key && (this.props.pickupSite.key != nextProps.pickupSite.key
            || (nextProps.waitListSite.key && this.props.waitListSite.key != nextProps.waitListSite.key)))
            || (!isEmptyObj(this.props.waitListSite) && isEmptyObj(nextProps.waitListSite.key))) {
            let buttons = Object.assign({}, this.state.buttons);
            buttons.right.disabled = this.props.isPreview;
            this.setState({buttons});
        }
        if(!this.props.isSaving && nextProps.isSaving || this.props.isSaving && !nextProps.isSaving) {
            let buttons = Object.assign({}, this.state.buttons);
            buttons.right.className = nextProps.isSaving?" loading":"";
            this.setState({buttons});
        }
    },
    render() {
        if (this.props.isFetching) {
            return <LoadingAnimation/>;
        }
        const pickupSiteLabel = isEmptyString(this.props.pickupSiteLabel) || this.props.pickupSiteLabel === 'null'
            ? translate("Pick-up site") : this.props.pickupSiteLabel;
        return (<fieldset disabled={this.props.isSaving}>
            <AccountNavigationHeader buttons={this.state.buttons} title={translate("Change") +" " + pickupSiteLabel}/>
            <PickupSiteSelection flowType={URLs.ACCOUNT}/>
            {this.getValidateAddressModal()}
        </fieldset>);
    }
});

const mapStateToProps =  (state) =>  {
    let summary = (state.summary || {});
    return {
        pickupSiteLabel: state.staticData.pickupSiteLabel,
        pickupSite: (summary.pickupSite ||{}),
        waitListSite: (summary.waitListSite||{}),
        nextDeliveryDateActual: summary.nextDeliveryDate,
        isFetching: isFetching(state, FetchingTypes.LOAD_SIGNUP_DATA),
        isSaving: isFetching(state, FetchingTypes.UPDATE_PICKUP_SITE),
        isPreview: (state.staticData || {}).isPreview,
        memberDetails: state.memberDetails,
        showAddressValidationMessage: state.account.showAddressValidationMessage
    };
};

const mapDispatchToProps =  (dispatch) => {
    return {
        checkIsDirty: (check, onLeaveCallBack) => {
            if (check)
                dispatch(checkIsDirty(onLeaveCallBack));
            else
                onLeaveCallBack();
        },
        cancel: (pickupSite, waitListSite, nextDeliveryDate) => {
            dispatch(setPickupSitesAndDeliveryDate(nextDeliveryDate, pickupSite, waitListSite));
            dispatch(setDirty(false));
            dispatch(setAccountMode(AccountModes.VIEW));
        },
        getPickupSiteAvailableForChange: () => {
            dispatch(getPickupSiteAvailableForChange())
        },
        save: (pickupSite, waitListSite) => {
            dispatch(updatePickupSite(pickupSite, waitListSite));
        },
        updateMemberLatLng:(lat, lng)=> {
            dispatch(setLatLng(lat, lng));
            dispatch(updateMemberLatLng(lat, lng));
        },
        setShowAddressValidationMessage: showAddressValidationMessage => {
            dispatch(setShowAddressValidationMessage(showAddressValidationMessage));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountChangePickupSite);



// WEBPACK FOOTER //
// ./src/containers/account/AccountChangePickupSite.js